<template lang="pug">
div.easyQuestion
  Form(:model="question")
    .question-stem
      Button(icon="md-add",style='color:#3A76D2;border: 1px solid #3A76D2;margin-left: 12px;transform: translateY(-10px);',
        @click='showAIDialog()',v-if='enableAI') AI生成
      Modal(v-model="aiDialogVisible" title="AI生成" @on-ok="generateCase")
        Form(:model="aiForm" :label-width="80")
          FormItem(label="生成数量")
            InputNumber(v-model="aiForm.count" :min="1" :max="10" placeholder="请输入生成数量")
          FormItem(label='提示词',prop="stem")
            Input(v-model='aiForm.system' placeholder='请填写提示词'
              type="textarea" :rows="3")
      FormItem
        //- span.left 4.
        Input(v-model.sync="question.stem" placeholder="题目内容")
      iDelModel(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
    FormItem(v-show="isEditTips")
      Input(v-model.sync="question.tips" placeholder="编辑提示信息")
    FormItem(label="参考答案" :label-width="80").answertext
      Input(v-model.sync="question.metas",type="textarea",:autosize="{minRows: 2,maxRows: 5}",:maxlength="500" :show-word-limit="true" placeholder="请输入参考答案")
    FormItem(style='margin-left:80px')
      Checkbox(v-model.sync="question.isShow",@on-change="handleChange") 显示答案
    FormItem(label="答案分析" :label-width="80")
      Input(v-model.sync="question.analysis",
        type="textarea",
        :autosize="{minRows: 2,maxRows: 5}",
        placeholder="请输入解析")
    //- FormItem(label="评分关键词" :label-width="80" v-show='question.isShow === false').keywords
    //-   iTag(:tag-data='question.scoringKeywords')
    FormItem(label="分值" :label-width="80")
      InputNumber(:max="100" :min="0" v-model.sync="question.score",:disabled="question.isShow")
    .question-edit
      isEditTips(:is-edit='isEditTips' :event='editTips')
</template>
<script>
import iTag from "@/components/common/iTag.vue";
import iDelModel from "@/components/common/iDelModel";
import isEditTips from "@/components/common/iEditTips";
import Bus from "../../utils/bus";
export default {
  components: {
    iTag,
    iDelModel,
    isEditTips
  },
  props: ["data", "haId", "taskId", "enableAI"],

  data() {
    return {
      question: {
        stem: "",
        tips: "",
        isShow: false,
        metas: "",
        analysis: "",
        scoringKeywords: ["暂无"],
        score: 0
      },
      saveKeywords: [],
      isEditTips: false,
      aiDialogVisible: false,
      aiForm: {}
    };
  },
  methods: {
    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { count: 1, system: "" };
    },
    generateCase() {
      if (this.taskId === "" || this.taskId === null || this.taskId === undefined) {
        this.$Message.error("无法生成！原因：需先保存当前场景！");
        return;
      }
      const data = {
        inputs: {
          opt_type: "ESSAYQUESTION",
          count: this.aiForm.count,
          pyId: this.$store.state.Case.basic.id,
          tsId: this.taskId,
          haId: this.haId,
          score: 2,
          system: this.aiForm.system
        }
      };
      this.$http.generateCase(data).then((res) => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          if (this.taskId !== this.haId) {
            Bus.$emit("refresh-task", this.taskId);
          } else {
            this.$emit("refresh-query");
          }
        }
      });
    },
    // 显示参考答案值改变
    handleChange(value) {
      if (value === true) {
        this.saveKeywords = this.question.scoringKeywords;
        /** 通过value值判断关键词,同时通过一个数组去保存关键字方便通过判断状态切换 */
        this.question.scoringKeywords = ["暂无"];
        this.question.score = 0;
      } else {
        this.question.scoringKeywords = ["暂无"];
      }
    },
    editTips() {
      // 编辑提示
      this.isEditTips = !this.isEditTips;
    },
    // 删除题目
    delModel() {
      this.$emit("delModel");
    }
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
      }
      //   this.$emit("data1:data", this.question);
    });
  }
};
</script>

<style lang="stylus">
.easyQuestion
  width 790px
  padding 24px 16px 24px 44px
  .question-stem
    position relative
    .ivu-form-item-content
      width 75%
  .answertext
    .ivu-input-word-count
      z-index 100
</style>
